import store from '@/store';

export default function(to, from, next) {
    if (store.getters['auth/isUser']) {
        next();
    } else {
        store.commit('auth/updateIntendedUrl', to.path);
        next({ name: 'login' });
    }
}
